// extracted by mini-css-extract-plugin
export var button = "Partners-module--button--903eb";
export var container = "Partners-module--container--799cb";
export var illustration = "Partners-module--illustration--7b492";
export var partner = "Partners-module--partner--0229a";
export var partners = "Partners-module--partners--1bb0d";
export var partnersHeader = "Partners-module--partnersHeader--e2541";
export var partnersWrapper = "Partners-module--partnersWrapper--7fe3c";
export var review = "Partners-module--review--2347d";
export var reviews = "Partners-module--reviews--c4e5a";
export var reviewsWrapper = "Partners-module--reviewsWrapper--dbe0d";
export var root = "Partners-module--root--27915";